var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.$style.wrapper,
      on: {
        mouseover: function($event) {
          _vm.mouseover = true
        },
        mouseleave: function($event) {
          _vm.mouseover = false
        }
      }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("MaskCoverPresenter", {
        attrs: {
          show: _vm.mouseover && _vm.canScrollLeft,
          "external-style": _vm.externalStyle,
          left: "",
          "data-event-type": "ui_event",
          "data-event-action": "click-button",
          "data-event-item-class": "ui/collection-carousel/arrow",
          "data-event-label": "left"
        },
        on: { click: _vm.progressCalculator.moveLeft }
      }),
      _vm._v(" "),
      _c("MaskCoverPresenter", {
        attrs: {
          show: _vm.mouseover && _vm.canScrollRight,
          "external-style": _vm.externalStyle,
          right: "",
          "data-event-type": "ui_event",
          "data-event-action": "click-button",
          "data-event-item-class": "ui/collection-carousel/arrow",
          "data-event-label": "right"
        },
        on: { click: _vm.progressCalculator.moveRight }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }